module.exports = __webpack_public_path__ + "static/media/Blur-asset-3.0aa05a43.png";